import { render, staticRenderFns } from "./UserCusDialog.vue?vue&type=template&id=58e5e374&scoped=true&"
import script from "./UserCusDialog.vue?vue&type=script&lang=js&"
export * from "./UserCusDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserCusDialog.vue?vue&type=style&index=0&id=58e5e374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e5e374",
  null
  
)

export default component.exports